<template>
  <transition name="fade">
    <div
        v-if="showModal"
        class="apg-modal-backdrop"
        role="dialog"
        aria-modal="true"
        aria-labelledby="unresponsive-modal-title"
    >
      <div class="apg-modal">
        <header class="apg-modal-header">
          <h3 id="unresponsive-modal-title">Unresponsive sensor data found</h3>
          <button type="button" class="btn-close" title="Close" @click="closeModal">
            <i class="bi bi-x-lg"></i>
          </button>
        </header>

        <section class="apg-modal-body table-responsive">
          <table class="table table-striped table-bordered mb-0">
            <thead>
              <tr>
                <th>Sensor</th>
                <th class="text-center">Date</th>
                <th class="text-center">Time</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, key) in unresponsiveData" :key="key">
                <td>{{ key }}</td>
                <td class="text-center">{{ format(new Date(item.x), 'MMM do yyyy') }}</td>
                <td class="text-center">{{ format(new Date(item.x), 'h:mm a') }}</td>
              </tr>
            </tbody>
          </table>
        </section>

        <footer class="apg-modal-footer"></footer>
      </div>
    </div>
  </transition>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { format } from 'date-fns';

export default {
  name: 'UnresponsiveDataModal',
  setup() {
    const store = useStore()
    return {
      showModal: computed(() => store.state.chart.chart_modals.unresponsive_data_modal),
      unresponsiveData: computed(() => store.state.chart.unresponsive_data.group_gateway_sensor),
      closeModal: () => store.commit('chart/showChartModal', { show_modal: false }),
      format
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity .2s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

/* FORCE a true fullscreen backdrop + centered modal */
.apg-modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Modal box */
.apg-modal {
  max-width: 90vw;
  max-height: 90vh;
  background: var(--color-bg-sec);
  border-radius: .5rem;
  box-shadow: 0 4px 16px rgba(0,0,0,.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header/Footer */
.apg-modal-header,
.apg-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .75rem 1rem;
  box-sizing: border-box;
  border-color: var(--color-border);
}

.apg-modal-header h3 {
  margin: 0;
  font-size: 1rem;
  color: var(--color-txt);
}

/* Scrollable body */
.apg-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  box-sizing: border-box;
}

/* Close button */
.btn-close {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--color-border);
  transition: color .2s;
}
.btn-close:hover {
  color: var(--color-sec);
}
</style>

